import { BlogPostState } from './blogPostReducer'

export const FETCH_BLOG_POST_DATA = 'FETCH_BLOG_POST_DATA'

export type FetchBlogPostData = {
  type: typeof FETCH_BLOG_POST_DATA
  payload: BlogPostState
}
